import { render, staticRenderFns } from "./ProfessionalData.vue?vue&type=template&id=42058d76&scoped=true"
import script from "./ProfessionalData.vue?vue&type=script&lang=js"
export * from "./ProfessionalData.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalData.vue?vue&type=style&index=0&id=42058d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42058d76",
  null
  
)

export default component.exports